export default __webpack_public_path__ + "static/media/landing-three-whales.e6aa5c88.png";